import { useCallback, useEffect, useRef, useState } from 'react'
import { getLocalStorage, LocalStorageKeys } from 'utils/local-storage'

export function useLocalStorage<T>(
  key: LocalStorageKeys | string,
  initialValue: T
): T {
  const initialValueRef = useRef(initialValue)

  const [value, setValue] = useState<T>(
    () => getLocalStorage<T>(key) ?? initialValueRef.current
  )

  const onStorageChange = useCallback(() => {
    setValue(getLocalStorage<T>(key) ?? initialValueRef.current)
  }, [key])

  useEffect(() => {
    window.addEventListener('storage', onStorageChange)
    return () => window.removeEventListener('storage', onStorageChange)
  }, [onStorageChange])

  return value
}
